<template>
	<div id="audio-toggle" @click="toggleStatus">
		<svg
			enable-background="new 0 0 512 512"
			height="512px"
			id="Layer_1"
			version="1.1"
			viewBox="0 0 512 512"
			width="512px"
			xml:space="preserve"
			xmlns="http://www.w3.org/2000/svg"
			xmlns:xlink="http://www.w3.org/1999/xlink"
			v-if="!getAudioStatus"
		>
			<path
				d="M511.603,303.727l-47.694,47.726l-47.726-47.726l-47.726,47.726l-47.693-47.726L368.457,256l-47.693-47.725l47.693-47.726  l47.726,47.726l47.726-47.726l47.694,47.726L463.907,256L511.603,303.727z M256.266,511.868L128.332,383.936H32.381  c-17.678,0-31.983-14.307-31.983-31.983V160.05c0-17.679,14.307-31.983,31.983-31.983h95.951L256.266,0.133  c0,0,31.983-3.998,31.983,31.983c0,173.535,0,425.718,0,447.769C288.249,515.866,256.266,511.868,256.266,511.868z M224.282,128.066  l-63.968,63.967H64.364v127.934h95.951l63.968,63.969V128.066z"
			/>
		</svg>

		<svg
			enable-background="new 0 0 512 512"
			height="512px"
			id="Layer_1"
			version="1.1"
			viewBox="0 0 512 512"
			width="512px"
			xml:space="preserve"
			xmlns="http://www.w3.org/2000/svg"
			xmlns:xlink="http://www.w3.org/1999/xlink"
			v-if="getAudioStatus"
		>
			<path
				d="M408.207,150.644c-12.984,12.954-33.993,12.954-46.979,0c-12.955-12.955-12.955-33.995,0-46.981l93.931-93.931  c12.986-12.955,33.995-12.955,46.981,0c12.954,12.955,12.954,33.995,0,46.98L408.207,150.644z M255.871,511.727L128.008,383.863  H32.11c-17.669,0-31.966-14.299-31.966-31.967V160.102c0-17.668,14.297-31.966,31.966-31.966h95.897L255.871,0.272  c0,0,31.966-3.996,31.966,31.966c0,191.233,0,478.926,0,447.522C287.837,515.722,255.871,511.727,255.871,511.727z M223.905,128.136  l-63.932,63.932H64.076v127.864h95.896l63.932,63.933V128.136z M383.734,287.965c-17.669,0-31.966-14.297-31.966-31.966  c0-17.668,14.297-31.966,31.966-31.966h95.897c17.669,0,31.966,14.298,31.966,31.966c0,17.669-14.297,31.966-31.966,31.966H383.734z   M408.207,361.355l93.933,93.931c12.954,12.986,12.954,34.026,0,46.98c-12.986,12.955-33.995,12.955-46.981,0l-93.931-93.931  c-12.955-12.986-12.955-34.025,0-46.98C374.214,348.4,395.223,348.4,408.207,361.355z"
			/>
		</svg>
	</div>
</template>

<script>
	import { mapGetters } from "vuex";

	export default {
		name: "AudioToggle",
		computed: mapGetters(["getAudioStatus"]),
		methods: {
			toggleStatus() {
				this.$store.commit("changeAudioStatus", {
					value: !this.getAudioStatus
				});
			}
		}
	};
</script>

<style lang="scss" scoped>
	#audio-toggle {
		position: fixed;
		bottom: 2.5%;
		right: 2.5%;
		width: fit-content;
		z-index: 999999;

		svg {
			height: 18px;
			width: 18px;
			fill: $textGold;
		}
	}
</style>
